import { ReactLenis } from "lenis/react";

// Smooth momentum scrolling wrapper. Respects reduced-motion via the
// prefers-reduced-motion CSS already in place (Lenis still improves UX).
export const SmoothScroll = ({ children }) => {
  const reduce =
    typeof window !== "undefined" &&
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  if (reduce) return <>{children}</>;

  return (
    <ReactLenis root options={{ lerp: 0.1, duration: 1.2, smoothWheel: true }}>
      {children}
    </ReactLenis>
  );
};
